import React from "react";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card, Stack } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SoftInput from "components/SoftInput";
import SoftSelect from "components/SoftSelect";
import Swal from "sweetalert2";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import Form from "react-bootstrap/Form";
import moment from "moment/moment";
// import "./editPost.css";
// import "../../EditModals/editStyle.css";
import DOMPurify from "dompurify";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./style.css";
// import { stateToHTML } from "draft-js-export-html";
import { Box, IconButton } from "@mui/material";
import { ThemeProvider } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
import Select from "react-select";
const stylesDD = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    // borderColor: state.isFocused ? "grey" : "red",
    fontSize: "14px",
  }),
  option: (base) => ({
    ...base,
    // border: `1px dotted red`,
    height: "100%",
    fontSize: "14px",
  }),
};

const EditBatch = (props) => {
  console.log(props, "prs11");
  const [form, setForm] = useState({
    batch_name: "",
    batch_startdt: "",
    batch_enddt: "",
    batch_type: "",
    batch_limit: "",
    batch_state: "",
    batch_district: "",
    batch_address: "",
    spoc_name: "",
    spoc_email: "",
    spoc_phone: "",
  });
  const [selectedDays, setSelectedDays] = useState([]);
  const { today, duration, courseMode } = { ...props.obj };
  console.log("obj", today, duration, courseMode);
  const daysOfWeek = [
    { label: "Sun", value: "6" },
    { label: "Mon", value: "0" },
    { label: "Tue", value: "1" },
    { label: "Wed", value: "2" },
    { label: "Thu", value: "3" },
    { label: "Fri", value: "4" },
    { label: "Sat", value: "5" },
  ];

  useEffect(() => {
    console.log(props.batchDetail, "pr111");
    setForm({
      batch_name: props.batchDetail?.batch_name || "",
      batch_startdt: props.batchDetail?.batch_startdt,
      batch_enddt: props.batchDetail?.batch_enddt,
      batch_type: props.batchDetail?.batch_type,
      batch_limit: props.batchDetail?.batch_limit,
      batch_state: props.batchDetail?.batch_state,
      batch_district: props.batchDetail?.batch_district,
      batch_address: props.batchDetail?.batch_address,
      spoc_name: props.batchDetail?.spoc_name,
      spoc_email: props.batchDetail?.spoc_email,
      spoc_phone: props.batchDetail?.spoc_mobile,
    });
    const response = props.batchDetail.weekly_off;
    // const response = [5, 6];
    // const typeData = typeof response;
    console.log("res", response);
    const preSelectedDays = response?.map((dayValue) =>
      daysOfWeek.find((day) => day.value === dayValue.toString())
    );
    setSelectedDays(preSelectedDays);
    console.log(selectedDays, "pr112", response);
  }, [props.batchDetail]);
  const [batchState, setBatchState] = useState("");
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  useEffect(() => {
    const fetchStateList = () => {
      axios
        .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/state`)
        .then((res) => {
          console.log("State", res.data);
          setStateList(res.data);
        })
        .catch((e) => {
          console.log(e);
        });
    };
    fetchStateList();
  }, []);

  useEffect(() => {
    const params = {
      state: batchState,
    };
    const paramString = new URLSearchParams(params).toString();
    const fetchCity = () => {
      axios
        .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/district?${paramString}`)
        .then((res) => {
          setDistrictList(res.data);

          console.log("District", res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    fetchCity();
  }, [batchState]);
  const batchFormE = useFormik({
    enableReinitialize: true,
    initialValues: {
      batch_name: props.batchDetail?.batch_name || "",
      start_date: props.batchDetail?.start_date || "",
      // end_date: props.batchDetail?.batch_enddt || "",
      // batch_type: props.batchDetail?.course_mode || "",
      batch_type: courseMode,
      batch_limit: props.batchDetail?.batch_limit || "",
      state: props.batchDetail?.batch_state || "",
      district: props.batchDetail?.batch_district || "",
      address: props.batchDetail?.batch_address || "",
      spoc_name: props.batchDetail?.spoc_name || "",
      spoc_email: props.batchDetail?.spoc_email || "",
      spoc_phone: props.batchDetail?.spoc_mobile || "",
      off_days: props.batchDetail?.weekly_off
        ? props.batchDetail?.weekly_off
            ?.map((dayValue) => daysOfWeek.find((day) => day.value == dayValue))
            .map((el) => el.value)
            .join(" ")
        : "",
      hrs_per_day: props.batchDetail?.hours_per_day || "",
    },
    validationSchema: Yup.object().shape({
      // batch_name: Yup.string().required("Please enter batch name"),
      // batch_limit: Yup.string().required("Please enter batch limit"),
      batch_type: Yup.string().required(" Please select batch type"),
      start_date: Yup.string().required("Please select batch start date"),
      // end_date: Yup.string().required("Please select batch end date"),
      state: Yup.string().required("Please select state"),
      district: Yup.string().required(" Please select district"),
      address: Yup.string().required(" Please enter address"),
      spoc_name: Yup.string().required("Please enter POC name"),
      spoc_name: Yup.string().required("Please enter POC email"),
      spoc_phone: Yup.string().required("Please enter POC mobil"),
    }),

    onSubmit: async (values, { resetForm }) => {
      console.log(JSON.stringify(values.off_days.split(",").map(Number)), values.off_days, "123f");
      const waitingPopup = Swal.fire({
        title: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      let formData = new FormData();
      formData.append("batch_name", values.batch_name);
      formData.append("batch_limit", values.batch_limit);
      formData.append("batch_startdt", values.start_date);
      // formData.append("batch_enddt", values.end_date);
      formData.append("batch_state", values.state);
      formData.append("batch_district", values.district);
      formData.append("batch_address", values.address);
      formData.append("course_mode", values.batch_type);
      formData.append("spoc_name", values.spoc_name);
      formData.append("spoc_email", values.spoc_email);
      formData.append("spoc_mobile", values.spoc_phone);
      formData.append("course_id", props.batchDetail?.course_id);
      formData.append("batch_id", props.batchDetail?.batch_id);
      formData.append(
        "weekly_off",
        values.off_days !== ""
          ? JSON.stringify(values.off_days.split(",").map(Number))
          : JSON.stringify([])
      );
      formData.append("hours_per_day", values.hrs_per_day);
      console.log(formData, "ss22");
      // skilling/list-batches?course_id=SMR_CO_Ca_Lo_755861
      // skilling/update-batch-status?batch_id=1

      await axios.patch(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/batch-edit`,
        formData
      );
      setTimeout(() => {
        waitingPopup.close(); // to close swal
      }, 0);
      Swal.fire({
        icon: "success",
        text: "Batch Edited Successfully",
        // showDenyButton: true,
        // confirmButtonText: "Add More",
      })
        .then((result) => {
          // if (result.isConfirmed) {
          //   // batchFormE.resetForm();
          //   batchFormE.handleReset();
          //   window.location.reload();
          // }
          batchFormE.handleReset();
          window.location.reload();
          props.setBatchModalE(false);
        })
        .catch((err) => {
          setTimeout(() => {
            waitingPopup.close();
          }, 0);
          Swal.fire({
            icon: "error",
            title:
              // err?.response?.data ? err.response.data["Developer Message"]:
              "Something went wrong",
            text: err?.response?.data ? err.response.data["User Message"] : "Something went wrong.",
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
  });

  return (
    <Modal
      show={props.batchModalE}
      onHide={() => {
        props.setBatchModalE(false);
        batchFormE.handleReset();
      }}
      centered
      style={{ margin: "0px" }}
      size="lg"
    >
      <Modal.Body>
        <SoftBox
          //   display="flex"
          //   justifyContent="space-between"
          //   alignItems="center"
          //   width="100%"
          //   px={2}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: -1.5,
          }}
        >
          {/* <SoftTypography fontWeight="medium" fontSize="20px" color="rgba(0, 0, 0, 0.88)" ml="7px">
            Edit Batch
          </SoftTypography> */}
          <p className="HeaderCSV">Edit Batch</p>
          <IconButton
            onClick={() => {
              props.setBatchModalE(false);
              batchFormE.handleReset();
            }}
          >
            {/* <CloseIcon fontSize="small" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M9.16992 14.8299L14.8299 9.16992"
                stroke="#3A3A3A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.8299 14.8299L9.16992 9.16992"
                stroke="#3A3A3A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                stroke="#3A3A3A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconButton>
          {/* <SoftBox
            sx={{ "&:hover": { cursor: "pointer" } }}
            onClick={() => {
              props.setBatchModalE(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M9.16992 14.8299L14.8299 9.16992"
                stroke="#3A3A3A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.8299 14.8299L9.16992 9.16992"
                stroke="#3A3A3A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                stroke="#3A3A3A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </SoftBox> */}
        </SoftBox>

        <SoftBox mt={2}>
          <SoftBox display="flex" flexDirection="column" alignItems="flex-start" px={2}>
            <SoftBox
              component="form"
              role="form"
              width="100%"
              // onSubmit={jobpostform.handleSubmit}
            >
              <Grid container>
                <SoftBox mt={2} width="100%" height="auto">
                  <Card sx={{ overflow: "visible" }}>
                    <SoftBox width="100%" height="auto">
                      <SoftBox component="form" role="form">
                        <SoftBox mb={2}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <SoftTypography
                                      fontWeight="medium"
                                      fontSize="16px"
                                      lineHeight="20px"
                                      mb={1}
                                    >
                                      Batch Name
                                    </SoftTypography>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <SoftInput
                                  type="text"
                                  placeholder="Batch Name"
                                  name="batch_name"
                                  id="batch_name"
                                  onChange={batchFormE.handleChange}
                                  value={batchFormE.values.batch_name}
                                />
                              </SoftBox>
                              {batchFormE.touched.batch_name && batchFormE.errors.batch_name ? (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  {batchFormE.errors.batch_name}{" "}
                                </span>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <SoftTypography
                                      fontWeight="medium"
                                      fontSize="16px"
                                      lineHeight="20px"
                                      mb={1}
                                    >
                                      Batch Start Date
                                    </SoftTypography>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <SoftInput
                                  type="date"
                                  placeholder="Batch Start Date"
                                  name="start_date"
                                  id="start_date"
                                  onChange={batchFormE.handleChange}
                                  value={batchFormE.values.start_date}
                                />
                              </SoftBox>
                              {batchFormE.touched.start_date && batchFormE.errors.start_date ? (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  {batchFormE.errors.start_date}{" "}
                                </span>
                              ) : null}
                            </Grid>
                            {/* <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <SoftTypography
                                      fontWeight="medium"
                                      fontSize="16px"
                                      lineHeight="20px"
                                      mb={1}
                                    >
                                      Batch End Date
                                    </SoftTypography>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <SoftInput
                                  type="date"
                                  placeholder="Batch End Date"
                                  name="end_date"
                                  id="end_date"
                                  onChange={batchFormE.handleChange}
                                  value={batchFormE.values.end_date}
                                />
                              </SoftBox>
                              {batchFormE.touched.end_date && batchFormE.errors.end_date ? (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  {batchFormE.errors.end_date}{" "}
                                </span>
                              ) : null}
                            </Grid> */}
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <SoftTypography
                                      fontWeight="medium"
                                      fontSize="16px"
                                      lineHeight="20px"
                                      mb={1}
                                    >
                                      Course Duration
                                    </SoftTypography>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <Select
                                  styles={stylesDD}
                                  placeholder="Duration"
                                  isDisabled
                                  // id="outlined-small-input"
                                  value={{ label: duration }}
                                />
                              </SoftBox>
                            </Grid>
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  // flexDirection="row"
                                  // justifyContent="space-between"
                                >
                                  <SoftTypography
                                    fontWeight="medium"
                                    fontSize="16px"
                                    lineHeight="20px"
                                    mb={1}
                                  >
                                    Weekly Off Days
                                  </SoftTypography>
                                  {/* <SoftBox
                                    sx={{
                                      color: "red",
                                      position: "inherit",
                                      paddingLeft: "2px",
                                      fontSize: "15px",
                                    }}
                                  >
                                    <sup>*</sup>
                                  </SoftBox> */}
                                </SoftBox>
                                {/* <SoftBox sx={{ display: "flex", width: "100%" }}> */}
                                <Select
                                  styles={stylesDD}
                                  placeholder="Select weekly off days"
                                  isMulti
                                  options={daysOfWeek}
                                  value={selectedDays}
                                  onChange={(e) => {
                                    if (e) {
                                      console.log(e);
                                      setSelectedDays(e);
                                      batchFormE.setFieldValue(
                                        "off_days",
                                        e.map((ele) => ele.value).join(",")
                                      );
                                    }
                                  }}
                                />
                              </SoftBox>
                            </Grid>
                            {duration.includes("hrs") ||
                              (duration.includes("Hours") && (
                                <Grid item xs={12} lg={4} md={6}>
                                  <SoftBox width="100%">
                                    <SoftBox
                                      width="100%"
                                      mb={1}
                                      display="flex"
                                      flexDirection="row"
                                      justifyContent="space-between"
                                    >
                                      <SoftBox display="flex" flexDirection="row">
                                        <SoftTypography
                                          fontWeight="medium"
                                          fontSize="16px"
                                          lineHeight="20px"
                                          mb={1}
                                        >
                                          No. of Hours Per Day
                                        </SoftTypography>
                                        <SoftBox
                                          sx={{
                                            color: "red",
                                            position: "inherit",
                                            paddingLeft: "2px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          <sup>*</sup>
                                        </SoftBox>
                                      </SoftBox>
                                    </SoftBox>
                                    <SoftInput
                                      type="number"
                                      placeholder="Enter no. of hours per day"
                                      name="hrs_per_day"
                                      id="hrs_per_day"
                                      inputProps={{
                                        min: 0,
                                        max: parseInt(duration.split(" ")[0]) && 24,
                                      }}
                                      onKeyPress={(e) => {
                                        console.log(e, "11se");
                                        if (e.key === "-" || e.key === "e" || e.key === "E") {
                                          e.preventDefault();
                                        }
                                      }}
                                      // onChange={batchForm.handleChange}
                                      onChange={(e) => {
                                        if (
                                          e.target.value <= parseInt(duration.split(" ")[0]) &&
                                          e.target.value <= 24
                                        ) {
                                          batchFormE.handleChange(e);
                                        }
                                      }}
                                      value={batchFormE.values.hrs_per_day}
                                    />
                                  </SoftBox>
                                </Grid>
                              ))}
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <SoftTypography
                                      fontWeight="medium"
                                      fontSize="16px"
                                      lineHeight="20px"
                                      mb={1}
                                    >
                                      Mode of Batch
                                    </SoftTypography>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <Select
                                  styles={stylesDD}
                                  placeholder="Select Mode"
                                  isDisabled
                                  options={[
                                    { label: "Online", value: "Online" },
                                    {
                                      label: "Classroom Training",
                                      value: "Classroom Training",
                                    },
                                  ]}
                                  onChange={
                                    (e) => batchFormE.setFieldValue("batch_type", e ? e.label : "")
                                    // setOrgNameID(e.value)
                                  }
                                  value={{ label: courseMode }}
                                />
                              </SoftBox>
                              {batchFormE.touched.batch_type && batchFormE.errors.batch_type ? (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  {batchFormE.errors.batch_type}{" "}
                                </span>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <SoftTypography
                                      fontWeight="medium"
                                      fontSize="16px"
                                      lineHeight="20px"
                                      mb={1}
                                    >
                                      Batch Limit
                                    </SoftTypography>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <SoftInput
                                  type="number"
                                  placeholder="Batch Limit"
                                  name="batch_limit"
                                  id="batch_limit"
                                  inputProps={{ min: 0 }}
                                  onKeyPress={(e) => {
                                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={batchFormE.handleChange}
                                  value={batchFormE.values.batch_limit}
                                />
                              </SoftBox>
                              {/* {batchFormE.touched.batch_limit && batchFormE.errors.batch_limit ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                      {batchFormE.errors.batch_limit}{" "}
                                    </span>
                                  ) : null} */}
                            </Grid>
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <SoftTypography
                                      fontWeight="medium"
                                      fontSize="16px"
                                      lineHeight="20px"
                                      mb={1}
                                    >
                                      Select State
                                    </SoftTypography>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <Select
                                  styles={stylesDD}
                                  placeholder="Select State"
                                  options={stateList}
                                  onChange={(e) => {
                                    batchFormE.setFieldValue("state", e ? e.label : "");
                                    setBatchState(e.label);
                                  }}
                                  value={{ label: batchFormE.values.state }}
                                />
                              </SoftBox>
                              {batchFormE.touched.state && batchFormE.errors.state ? (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  {batchFormE.errors.state}{" "}
                                </span>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <SoftTypography
                                      fontWeight="medium"
                                      fontSize="16px"
                                      lineHeight="20px"
                                      mb={1}
                                    >
                                      Select District
                                    </SoftTypography>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <Select
                                  styles={stylesDD}
                                  placeholder="Select District"
                                  options={districtList}
                                  onChange={
                                    (e) => batchFormE.setFieldValue("district", e ? e.label : "")
                                    // setOrgNameID(e.value)
                                  }
                                  value={{ label: batchFormE.values.district }}
                                />
                              </SoftBox>
                              {batchFormE.touched.district && batchFormE.errors.district ? (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  {batchFormE.errors.district}{" "}
                                </span>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <SoftTypography
                                      fontWeight="medium"
                                      fontSize="16px"
                                      lineHeight="20px"
                                      mb={1}
                                    >
                                      Address
                                    </SoftTypography>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <SoftInput
                                  type="text"
                                  placeholder="Address"
                                  name="address"
                                  id="address"
                                  onChange={batchFormE.handleChange}
                                  value={batchFormE.values.address}
                                />
                              </SoftBox>
                              {batchFormE.touched.address && batchFormE.errors.address ? (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  {batchFormE.errors.address}{" "}
                                </span>
                              ) : null}
                            </Grid>
                          </Grid>
                          <hr />
                          <Grid container spacing={2}>
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <Tooltip key="1" title="Person of Contact" position="top">
                                      <SoftTypography
                                        fontWeight="medium"
                                        fontSize="16px"
                                        lineHeight="20px"
                                        mb={1}
                                      >
                                        POC Name
                                      </SoftTypography>
                                    </Tooltip>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <SoftInput
                                  type="text"
                                  placeholder="POC Name"
                                  name="spoc_name"
                                  id="spoc_name"
                                  onChange={batchFormE.handleChange}
                                  value={batchFormE.values.spoc_name}
                                />
                              </SoftBox>
                              {batchFormE.touched.spoc_name && batchFormE.errors.spoc_name ? (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  {batchFormE.errors.spoc_name}{" "}
                                </span>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <Tooltip key="1" title="Person of Contact" position="top">
                                      <SoftTypography
                                        fontWeight="medium"
                                        fontSize="16px"
                                        lineHeight="20px"
                                        mb={1}
                                      >
                                        POC Email
                                      </SoftTypography>
                                    </Tooltip>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <SoftInput
                                  type="text"
                                  placeholder="POC Email"
                                  name="spoc_email"
                                  id="spoc_email"
                                  onChange={batchFormE.handleChange}
                                  value={batchFormE.values.spoc_email}
                                />
                              </SoftBox>
                              {batchFormE.touched.spoc_email && batchFormE.errors.spoc_email ? (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  {batchFormE.errors.spoc_email}{" "}
                                </span>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} lg={4} md={6}>
                              <SoftBox width="100%">
                                <SoftBox
                                  width="100%"
                                  mb={1}
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <SoftBox display="flex" flexDirection="row">
                                    <Tooltip key="1" title="Person of Contact" position="top">
                                      <SoftTypography
                                        fontWeight="medium"
                                        fontSize="16px"
                                        lineHeight="20px"
                                        mb={1}
                                      >
                                        POC Mobile
                                      </SoftTypography>
                                    </Tooltip>
                                    <SoftBox
                                      sx={{
                                        color: "red",
                                        position: "inherit",
                                        paddingLeft: "2px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      <sup>*</sup>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                                <SoftInput
                                  type="tel"
                                  placeholder="Enter mobile number"
                                  inputProps={{
                                    maxLength: "10",
                                  }}
                                  id="spoc_phone"
                                  name="spoc_phone"
                                  onChange={batchFormE.handleChange}
                                  value={batchFormE.values.spoc_phone}
                                />
                              </SoftBox>
                              {batchFormE.touched.spoc_phone && batchFormE.errors.spoc_phone ? (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  {batchFormE.errors.spoc_phone}{" "}
                                </span>
                              ) : null}
                            </Grid>
                          </Grid>
                        </SoftBox>
                      </SoftBox>
                    </SoftBox>
                  </Card>
                </SoftBox>
              </Grid>
            </SoftBox>
          </SoftBox>
        </SoftBox>

        <SoftBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ ml: "auto", mr: "auto" }}
        >
          <Box sx={{ p: 1 }}>
            <SoftBox
              sx={{
                height: "45px",
                backgroundColor: "#3B5092",
                borderRadius: "5px",
                width: "100px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={batchFormE.handleSubmit}
            >
              <SoftTypography
                display="flex"
                justifyContent="center"
                sx={{
                  color: "#fff",
                  fontSize: "15px",
                  fontWeight: "medium",
                  lineHeight: "19px",
                }}
              >
                Submit
              </SoftTypography>
            </SoftBox>
          </Box>

          <Box sx={{ p: 1 }}>
            <SoftBox
              sx={{
                height: "45px",
                backgroundColor: "#FFFFFF",
                border: "1px solid #3B5092",
                borderRadius: "5px",
                width: "100px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                props.setBatchModalE(false);
                batchFormE.handleReset();
              }}
            >
              <SoftTypography
                display="flex"
                justifyContent="center"
                sx={{
                  color: "#3B5092",
                  fontSize: "15px",
                  fontWeight: "medium",
                  lineHeight: "19px",
                }}
              >
                Cancel
              </SoftTypography>
            </SoftBox>
          </Box>
        </SoftBox>
      </Modal.Body>
    </Modal>
  );
};
EditBatch.propTypes = {
  batchModalE: PropTypes.bool.isRequired,
  setBatchModalE: PropTypes.func.isRequired,
  batchDetail: PropTypes.object.isRequired,
  obj: PropTypes.object.isRequired,
  // handleOrgFunc: PropTypes.func.isRequired,
  // handleRoleFunc: PropTypes.func.isRequired,
  //   fetchadminList: PropTypes.func.isRequired,
};
export default EditBatch;
